import { useMutation } from "@apollo/client";
import { DELETE_USER, GET_USERS } from "../../GraphQL/Users";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteUserDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteUser, { loading, error }] = useMutation(DELETE_USER, {
    variables: { id: props.user.id },
    refetchQueries: [GET_USERS],
    onCompleted: () => {
      notifySuccess("User deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={props.user.username}
      onConfirm={deleteUser}
      loading={loading}
      error={error}
      confirmTestId="deleteDeleteUserDialogButton"
      cancelTestId="closeDeleteUserDialogButton"
    />
  );
};

export default DeleteUserDialog;
